import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Carousel from '@nerdwallet/react-carousel';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import TestimonialTile from './testimonial-tile';
import styles from './testimonials.module.less';

const Testimonials = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <TestimonialTile {...tile} key={`item-${nav}`} />
  ));

  return (
    <BedrockImpression entityName="hp_reg_reviews_successful_display">
      <div className={styles.testimonialsContainer}>{renderedTiles}</div>
      <div>
        <Carousel
          id="testimonials"
          entityName="testimonials"
          decorateNav={false}
          enableDotNavigation
          arrows={false}
          dots
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          slidesToShow="1.3"
          className={styles.testimonialsCarousel}
        >
          {renderedTiles}
        </Carousel>
      </div>
    </BedrockImpression>
  );
};

Testimonials.displayName = 'Testimonials';

Testimonials.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(TestimonialTile.propTypes)),
};

export default Testimonials;
